import { Content, GroupField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { Simplify } from '../../../../../prismicio-types';

import styles from './serviceContextList.module.scss';
import { BulletIcons } from '@/assets';

interface ServiceContextListProps {
  items: GroupField<
    Simplify<Content.ServiceAdvantagesSliceDefaultPrimaryItemsItem>
  >;
  activeItem: number;
  isVisible: boolean;
}

const components: JSXMapSerializer = {
  heading5: ({ children }) => <h5 className={styles.heading}>{children}</h5>,
};

export const ServiceContextList = ({
  items,
  activeItem,
  isVisible,
}: ServiceContextListProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <ul className={styles.list}>
      {items.map((item, index) => (
        <li
          key={item.description}
          className={`${styles.item} ${activeItem === index ? styles.visible : styles.hidden}`}
        >
          <div className={`${styles.heading_wrapper} ${isVisibleStyles}`}>
            <PrismicRichText field={item.heading} components={components} />
          </div>
          <p
            className={`${styles.paragraph} ${styles.description} ${isVisibleStyles}`}
          >
            {item.description}
          </p>
          <p
            className={`${styles.paragraph} ${styles.advantage} ${isVisibleStyles}`}
          >
            <BulletIcons icon="check color" /> {item.advantage}
          </p>
        </li>
      ))}
    </ul>
  );
};
